import PropTypes from "prop-types";
import { Card } from "@/config/antd";
import { FaEdit } from "@/config/react_icons";

const AllocatedFundsCard = ({ subEvent, spentPercentage }) => {
  return (
    <div className="mt-8">
      <Card className="w-full">
        <h3 className="text-black text-small text-left mb-1">
          ALLOCATED FUNDS
        </h3>
        <div className="flex justify-between items-center">
          <h2 className="heading-large text-darkGrey">
            ₦
            {Number(subEvent?.budgetaryAllocation || 0).toLocaleString(
              "en-US",
              {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }
            )}
            <span className="text-[24px]">.00</span>
          </h2>
        </div>
        <div className="mt-4 bg-lighterBlue rounded-lg p-1 flex justify-between items-center">
          <div className="flex text-small items-center gap-2">
            <div className="flex text-small items-center bg-danger text-white px-2 py-1 rounded-full gap-1">
              <span>↑</span>
              <span className="text-small font-medium">
                {spentPercentage}% spent
              </span>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-darkGrey text-small whitespace-nowrap font-medium cursor-pointer">
              Modify Allocated funds
            </span>
            <FaEdit className="text-darkGrey text-small" />
          </div>
        </div>
      </Card>
    </div>
  );
};

AllocatedFundsCard.propTypes = {
  subEvent: PropTypes.object,
  spentPercentage: PropTypes.number,
};

export default AllocatedFundsCard;
